import { useEffect, useState } from "react";

import RsltOutcom from "./Rslt_outcome";
import RsltPortfolio from "./Rslt_portfolio";

import "../../styles/base.css";
import "../../styles/board.css";
import "../../styles/common.css?ver=1";
import "../../styles/is.css?ver=2";

//import "../../styles/base.css";
//import "../../styles/board.css";
//import "../../styles/common.css?ver=1";
//import "../../styles/is.css?ver=2";
//import "../../styles/common.css";
import { useNavigate } from "react-router-dom";

interface ReusultProps {
  tabIndex: number;
}

const Result: React.FC<ReusultProps> = ({ tabIndex }) => {
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(tabIndex);

  const menuArr = [
    { name: "구축실적", content: <RsltOutcom />, path: "rslt_outcome" },
    { name: "포트폴리오", content: <RsltPortfolio />, path: "rslt_portfolio" },
  ];

  const selectMenuHandler = ({ index, path }: any) => {
    setCurrentTab(index);
    navigate(`/${path}`);
  };

  useEffect(() => {
    setCurrentTab(tabIndex);
    window.scrollTo(0, 0);
  }, [tabIndex]);

  return (
    <div>
      <div className="sub-visual subv-2">
        <h1>
          <span>BUSINESS RESULT</span>
          <p>고객의 성공적인 사업을 위한 맞춤형 솔루션을 제공합니다.</p>
        </h1>
        <div className="sub-depth-1">
          <ul className="tab-list" style={{ cursor: "pointer" }}>
            {" "}
            {menuArr.map((tab, index) => (
              <li key={index} className={currentTab === index ? "active" : ""} onClick={() => selectMenuHandler({ index, path: tab.path })}>
                {tab.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div>{menuArr[currentTab].content}</div>
    </div>
  );
};

export default Result;
